import { memo } from "react";
import { ITeamMember } from "../../../../../models/session";
import { IconFaculty } from "../../../Icons/Icons";
import styles from "./index.module.scss";

interface InfocolProps {
    communities: Array<any>;
    sessionTeam?: Array<ITeamMember>;
    sessionTitle: string;
    room: string;
    sessionUpdate: boolean;
    entityLanguage: string;
}

const InfoCol = ({ communities, room, sessionTitle, sessionUpdate, sessionTeam, entityLanguage }: InfocolProps) => {
    return (
        <div className={styles.infoContainer}>
            <div>
                <div className={styles.className}>{communities && Array.isArray(communities) ? communities.map((c: any) => c.name) : ""}</div>
                <div className={styles.classTeamContainer}>
                    {sessionTeam
                        && sessionTeam
                            .filter((t: ITeamMember) => t.Type__c === "Faculty" || t.Type__c === "Guest Speaker")
                            .map((t: ITeamMember, index) =>
                                t.Name__r && (
                                    <div className={styles.facultyName} key={t.Id + "facultyName" + index}>
                                        <div className="facultyIcon">
                                            <IconFaculty />
                                        </div>
                                        <div className={entityLanguage === "English" ? "mr-1" : "ml-1"}>{t.Name__r ? t.Name__r.FirstName : null}</div>
                                        <div>
                                            {t.Name__r ? (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i) ? t.Name__r.LastName[0] : t.Name__r.LastName) : null}
                                        </div>
                                    </div>
                                )
                            )
                    }
                </div>
                <div className={styles.teamName}>{sessionTitle}</div>
            </div>
            <div>
                <div>
                    <div className={styles.room}>{room || ""}</div>
                    {sessionUpdate && <div className="loader"></div>}
                </div>
            </div>
        </div>
    );
};

export default memo(InfoCol);